import React from "react";
import { Switch, Typography, Box } from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/reducers";
import { IFormCategoryModel, ILookupItemModel } from "../../types/types";
import { useQuery } from "@tanstack/react-query";
import { AppDispatch } from "../../store/store";
import {
  getHiddenFields,
  hideField,
  showField,
} from "../../store/modules/hiddenFields/hiddenFieldActions";
import { saveCoAgentFilter } from "../../store/modules/coAgentFilter/coAgentFilterActions";
import { clearCoAgentFilter } from "../../store/modules/coAgentFilter/coAgentFilterSlice";
import LoadingDialog from "../Dialogs/LoadingDialog";

interface FieldVisibilitySettingsProps {}

const FieldVisibilitySettings: React.FC<
  FieldVisibilitySettingsProps
> = ({}) => {
  const { data, userData } = useSelector(
    (state: RootState) => state.commonData,
  );

  const { loading, error, hiddenFields, loaded, isToggling } = useSelector(
    (state: RootState) => state.hiddenFields,
  );

  const dispatch = useDispatch<AppDispatch>();

  useQuery({
    queryKey: ["userCustomData"],
    queryFn: () => {
      // if (!userDataLoaded) {
      dispatch(getHiddenFields());
      return Promise.resolve(null);

      // }
    },
    refetchOnWindowFocus: false,
    enabled: !loaded,
  });
  // if (error) return <Typography color="error">{error}</Typography>;

  const handleToggle = (
    item: ILookupItemModel | undefined,
    category: IFormCategoryModel,
  ) => {
    if (!item) {
      // Hiding the field
      dispatch(hideField(category.id!, category.internalName!));

      // Clear co-agent filter if hiding the coAgent category
      if (category.internalName === "coAgent") {
        dispatch(clearCoAgentFilter());
      }
    } else {
      dispatch(showField(item.id!));
    }
  };

  return (
    <>
      <LoadingDialog open={loading || isToggling} />
      <Box
        sx={{
          background: "#fff",
          borderRadius: "12px",
          boxShadow: "0 2px 8px 0 rgba(0,0,0,0.04)",
          p: { xs: 2, md: 4 },
          mb: 1,
          minHeight: 400,
        }}
      >
        {data?.categories?.map((field) => {
          const lookup = hiddenFields?.find(
            (f) => f.name === field.internalName,
          );
          const isHidden = !!lookup;
          return (
            <Box
              key={field.id}
              sx={{
                display: "flex",
                alignItems: "center",
                background: "#F7F9FB",
                borderRadius: "8px",
                px: 2,
                py: 1.5,
                mb: 1.5,
              }}
            >
              <Typography
                sx={{
                  fontWeight: 600,
                  color: isHidden ? "#B0B0B0" : "#222",
                  fontSize: "1.1rem",
                  flexGrow: 1,
                }}
              >
                {field.name}
              </Typography>
              <Switch
                checked={!isHidden}
                onChange={() => handleToggle(lookup, field)}
                sx={{
                  mr: 2,
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "primary.main",
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#1976d2",
                  },
                }}
              />
            </Box>
          );
        })}
      </Box>
    </>
  );
};

export default FieldVisibilitySettings;
